export default __webpack_public_path__ + "static/media/about-us-drums-3.c0501ea1.jpeg";